import { render } from "./social-links.presentational.vue?vue&type=template&id=2c216e93"
import script from "./social-links.presentational.vue?vue&type=script&lang=js"
export * from "./social-links.presentational.vue?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__